import { render, staticRenderFns } from "./ShortCuts.vue?vue&type=template&id=3a5e1316"
import script from "./ShortCuts.vue?vue&type=script&lang=ts"
export * from "./ShortCuts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports